import React, { useState, useEffect } from "react";
import {
	Modal,
	Form,
	Select,
	Button,
	message,
} from "antd";
import useAxios from "../../utilities/useAxios";

const { Option } = Select;

const SelectDepartmentModal = ({
	visible,
	onCancel,
	onSelect,
}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [departments, setDepartments] = useState([]);

	useEffect(() => {
		if (visible) {
			getDepartments();
		}
	}, [visible]);

	const getDepartments = async () => {
		try {
			const response = await useAxios.get(
				"/department/departments/"
			);
			if (response.status === 200) {
				setDepartments(response.data);
			}
		} catch (error) {
			message.error(
				"소속기관 목록을 불러오는데 실패했습니다."
			);
		}
	};

	const handleSubmit = async () => {
		try {
			setLoading(true);
			const values = await form.validateFields();

			const selectedDepartment = departments.find(
				(d) => d.id === values.department
			);

			if (selectedDepartment) {
				onSelect({
					departmentId: selectedDepartment.id,
					departmentName: selectedDepartment.name,
				});
				handleCancel();
			}
		} catch (error) {
			message.error("소속기관 선택에 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		form.resetFields();
		onCancel();
	};

	return (
		<Modal
			title="소속기관 선택"
			open={visible}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>
					취소
				</Button>,
				<Button
					key="submit"
					type="primary"
					loading={loading}
					onClick={handleSubmit}>
					선택
				</Button>,
			]}
			width={500}>
			<Form form={form} layout="vertical">
				<Form.Item
					name="department"
					label="소속기관"
					rules={[
						{
							required: true,
							message: "소속기관을 선택해주세요",
						},
					]}>
					<Select placeholder="소속기관 선택">
						{departments.map(
							(department) => (
								<Option
									key={
										department.id
									}
									value={
										department.id
									}>
									{
										department.name
									}
								</Option>
							)
						)}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default SelectDepartmentModal;



